import { useEffect, useState } from 'react';

export function useMediaQuery(query: string, fallback = false) {
    const [matches, setMatches] = useState(() => fallback);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const media = window.matchMedia(query);

        const listener = () => setMatches(media.matches);

        listener();

        media.addEventListener('change', listener);

        return () => {
            return media.removeEventListener('change', listener);
        };
    }, [query]);

    return matches;
}
